import { z } from 'zod'

export const kakaoServiceTermsResponseSchema = z.object({
  id: z.number(),
  service_terms: z
    .array(
      z.object({
        tag: z.string(),
        required: z.boolean(),
        agreed: z.boolean(),
        revocable: z.boolean(),
        agreed_at: z.string().optional(),
        agreed_by: z.string().optional(),
      }),
    )
    .optional(),
})

export type KakaoServiceTermsResponse = z.infer<typeof kakaoServiceTermsResponseSchema>
